module.exports = __webpack_public_path__ + "img/database-icon.9608cb10.png";